import { Component, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { trigger, state, style, transition, animate, sequence } from '@angular/animations';

import { BehaviorSubject, filter, Subscription } from 'rxjs';

import { AreaTypeEnum } from '@commons/enums/area-type.enum';
import { Area } from '../../../commons/models/domain/Area';
import { PanelNavigationService } from '@commons/services/navigation/panel-navigation.service';
import { AreaDrawerService, State as AreaDrawerState } from '@commons/services/map/drawer/area/area-drawer.service';
import { AreaService } from '@commons/services/area/area.service';

export enum ViewMode {
    List = 0,
    Form = 1
}

@Component({
    selector: 'tk-area-list-lite',
    templateUrl: './area-list-lite.component.html',
    styleUrls: ['./area-list-lite.component.less'],
    encapsulation: ViewEncapsulation.None,
  animations: [
    trigger('openClose', [
      transition(":enter", [style({transform: 'translateX(-264px)'}), animate('0.1s')]),
      transition(":leave", [sequence([style({left: '56px'}), animate('0.1s', style({left: '-264px'}))])]),
    ])
  ]
})
export class AreaListLiteComponent implements OnDestroy {


    public filterHeight = 152;


    /**
     * Areas
     */
    public areas?: Area[];

    /**
     * Subsription to selected area stream
     */
    private selectedAreaSub: Subscription;

    /**
     * Subject for selected area type communication: create area componenet -> form component
     */
    public selectedAreaTypeSubject: BehaviorSubject<AreaTypeEnum | undefined> = new BehaviorSubject<AreaTypeEnum | undefined>(undefined);

    /**
     * Subsription to selected area type stream
     */
    private selectedAreaTypeSub: Subscription;


    /**
     * Subscription to saving done signal stream
     */
    private savingDoneSub?: Subscription;

    /**
     * Subscription to areas
     */
    private areaSub: Subscription;

    /**
     * Subscription to navigation changes
     */
    private navSub: Subscription;

    /**
     * Flag indicating whether areas list is visible
     */
    public isVisible = false;

    /**
     * View mode
     */
    public viewMode: ViewMode = ViewMode.List;

    /**
     * For template
     */
    public ViewMode = ViewMode;

    /**
     * Selected area
     */
    public selectedArea?: Area;
    public selectedAreaId?: number;


    /**
     * Event list lite's constructor
     * @param $nav navigation service
     * @param $area area service
     * @param $areaDrawer area drawer service
     */
    constructor(
        private $nav: PanelNavigationService,
        private $area: AreaService,
        private $areaDrawer: AreaDrawerService
    ) {
        // Subscribe to stream of url changes
        this.navSub = this.$nav.getVisibilitySubject()
            .pipe(filter((item: any) => (
                !item.subsites
                || item.subsites.indexOf('area-lite') !== -1
            )))
            .subscribe(change => {
                this.isVisible = change.show;
                if (!this.isVisible) {
                    this.viewMode = ViewMode.List;
                    this.$areaDrawer.remove();
                    this.selectedArea = undefined;
                    this.selectedAreaId = undefined;
                }
            });

        // Get areas
        this.areaSub = this.$area.getAreaList$().subscribe(areas => {
            if (this.isVisible) {
                this.areas = areas;
            }
        });

        // Subscribe for selected area stream
        this.selectedAreaSub = this.$areaDrawer.selectedAreaSubject.subscribe(area => {
            this.selectedArea = area;
            this.viewMode = ViewMode.Form;
        });

        // Subscribe for selected area types stream
        this.selectedAreaTypeSub = this.selectedAreaTypeSubject.subscribe(areaType => {
            this.viewMode = areaType ? ViewMode.Form : ViewMode.List;
            if (this.viewMode !== ViewMode.List) {
                this.selectedAreaId = undefined;
                this.selectedArea = undefined;
            }
        });
    }


    /**
     * Ng on destroy lifecycle hook
     */
    public ngOnDestroy(): void {

        if (this.navSub) {
            this.navSub.unsubscribe();
        }
        if (this.areaSub) {
            this.areaSub.unsubscribe();
        }
        if (this.savingDoneSub) {
            this.savingDoneSub.unsubscribe();
        }
        if (this.selectedAreaSub) {
            this.selectedAreaSub.unsubscribe();
        }
        if (this.selectedAreaTypeSub) {
            this.selectedAreaTypeSub.unsubscribe();
        }
    }


    /**
     * Selects area and switches to form view mode
     * @param area area
     */
    public selectArea(area?: Area): void {
        this.$areaDrawer.selectedAreaSubject.next(area);
    }


    public onCancel() {
        if (this.selectedArea) {
            this.selectedAreaId = this.selectedArea.Id;
            this.showArea(this.selectedArea);
            this.selectedArea = undefined;
        } else {
            this.$areaDrawer.setArea(undefined);
            this.$areaDrawer.remove();
        }
        this.$areaDrawer.areaDrawerState = AreaDrawerState.Default;
        this.$areaDrawer.drawingDoneSubject.next();
    }

    public onSelect(item: Area) {


        // odznaczenie i zaznaczenia
        if (item.Id && this.selectedAreaId === item.Id) {
            this.selectedAreaId = undefined;
            this.showArea(undefined);
        } else {
            this.selectedAreaId = item.Id;
            this.showArea(item);
        }

    }

    public onSave(item: Area) {
        this.selectedArea = item;
        this.$areaDrawer.areaDrawerState = AreaDrawerState.Default;
        this.$areaDrawer.drawingDoneSubject.next();
    }

    public onDelete(item: Area) {
        this.selectedArea = undefined;
        this.selectedAreaId = undefined;
        this.viewMode = ViewMode.List;
        this.onCancel();
    }

    private showArea(item?: Area) {
        console.log('show area');
        this.$areaDrawer.setArea(undefined);
        this.$areaDrawer.remove();
        this.$areaDrawer.setArea(item);
        this.$areaDrawer.draw();
        this.$areaDrawer.fitBoundsToVisibleArea();
    }


    handleOnHeightChanged(evt: any) {
        // filr ma 133px a lista musi się zaczynać na 140px
        // stad przesunięcie
        this.filterHeight = evt + 68;
    }

}
